'use client';

import React, { useEffect, useRef, useState } from 'react';

const faqData = [
  {
    question: "Qu'est-ce que CorsAsia ?",
    answer: "CorsAsia est une chaine de restaurants asiatiques en Corse fondée en 2020. Nous proposons deux concepts : Buffet d'Asie, des restaurants buffet à volonté, et Market Traiteur, des espaces de vente à emporter avec épicerie asiatique et plats cuisinés."
  },
  {
    question: "Combien de restaurants CorsAsia existe-t-il en Corse ?",
    answer: "CorsAsia compte 6 points de vente en Corse : 3 restaurants Buffet d'Asie et 3 espaces Market Traiteur, répartis entre Ajaccio, Bastia et Porto-Vecchio."
  },
  {
    question: "Comment réserver une table chez Buffet d'Asie ?",
    answer: "Vous pouvez réserver une table dans l'un de nos restaurants Buffet d'Asie directement sur notre site web, par téléphone ou en vous rendant sur place. La réservation est recommandée aux heures de pointe."
  },
  {
    question: "Quels types de cuisine propose CorsAsia ?",
    answer: "Nos restaurants proposent une cuisine asiatique variée : plats chinois, japonais, thaïlandais, vietnamiens et coréens. Nos buffets à volonté offrent un large choix d'entrées, plats chauds, woks en direct et desserts."
  },
  {
    question: "Quels sont les horaires d'ouverture ?",
    answer: "Les restaurants Buffet d'Asie sont ouverts le midi de 12h à 14h et le soir de 19h à 22h30. Les Market Traiteur sont ouverts du lundi au samedi de 9h à 20h. Les horaires peuvent varier selon les points de vente."
  },
  {
    question: "Y a-t-il des options végétariennes ou véganes ?",
    answer: "Oui, nos buffets proposent de nombreux plats végétariens et végans : légumes sautés, tofu, nouilles végétariennes, riz et entrées variées. Notre équipe peut vous orienter sur place."
  },
  {
    question: "Peut-on commander à emporter ?",
    answer: "Oui, nos Market Traiteur sont spécialisés dans la vente à emporter avec des plats cuisinés frais, des plateaux repas et une épicerie asiatique. Certains Buffet d'Asie proposent également des formules à emporter."
  },
  {
    question: "Où sont situés les restaurants CorsAsia ?",
    answer: "Nos 6 points de vente se trouvent dans 3 villes corses : Ajaccio, Bastia et Porto-Vecchio. Chaque ville dispose d'un restaurant Buffet d'Asie et d'un espace Market Traiteur."
  }
];

const FAQSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const reveals = entry.target.querySelectorAll('.reveal-on-scroll');
            reveals.forEach((el, i) => {
              setTimeout(() => el.classList.add('revealed'), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="faq-section" ref={sectionRef} className="py-24 bg-charcoal relative overflow-hidden">
      <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] rounded-full bg-corsasia/5 blur-[100px] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6">
        <div className="reveal-on-scroll text-center mb-16">
          <p className="text-clay text-xs uppercase tracking-widest font-sans font-medium mb-4">
            Questions Fréquentes
          </p>
          <h2
            className="font-serif italic text-parchment leading-tight mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)' }}
          >
            Tout savoir sur CorsAsia
          </h2>
          <p className="font-sans text-parchment/50 text-lg max-w-2xl mx-auto">
            Retrouvez les réponses aux questions les plus posées sur nos restaurants, notre cuisine et nos services.
          </p>
        </div>

        <div className="reveal-on-scroll space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-charcoal-light/30 rounded-2xl border border-clay/10 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-charcoal-light/20 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="font-sans font-semibold text-parchment pr-4">
                  {item.question}
                </span>
                <svg
                  className={`w-5 h-5 text-clay shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <p className="px-6 pb-5 font-sans text-parchment/60 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;